import React from 'react'
import { withApollo } from '@apollo/client/react/hoc'
import { injectIntl } from 'react-intl'
import { SelectMultiplePrograms } from '../tracks/SelectProgram'
import { ThirdPartyDeviceProgramMutation } from './Queries'
import * as Utils from '../../components/Utils'
import { hasAccess, hasPermission } from '../../auth'

const ThirdPartyDevicePrograms = ({
	thirdPartyDeviceId,
	programs,
	client,
	thirdPartyDeviceTeamId
}) => {
	const onSelect = async (programIds) => {
		try {
			const r = await client.mutate(
				ThirdPartyDeviceProgramMutation(thirdPartyDeviceId, programIds)
			)
			Utils.parseMutationResponse(r)
		} catch (e) {
			Utils.displayError(e)
		}
	}

	const canUpgradePrograms =
		hasPermission('thirdPartyDevice:edit:setPrograms') &&
		hasAccess('thirdPartyDevice:edit', thirdPartyDeviceTeamId)

	return (
		<SelectMultiplePrograms
			disabled={!canUpgradePrograms}
			selectedIds={programs.map((program) => program._id)}
			onSelect={(ids) => onSelect(ids)}
		/>
	)
}

export default withApollo(injectIntl(ThirdPartyDevicePrograms))
